var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiLine = function SvgApiLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.823 8.82 7.645 10l2.357 2.357 1.179-1.177 1.177 1.177-1.177 1.18 1.178 1.178-2.357 2.356a3.334 3.334 0 0 1-4.59.119l-.123-.119-1.768 1.768-2.357-2.357 1.768-1.767a3.335 3.335 0 0 1 0-4.715l2.356-2.356L6.467 8.82l1.179-1.178zm10.018-5.302-1.768 1.767a3.336 3.336 0 0 1 0 4.715l-2.357 2.356-7.071-7.07 2.357-2.357a3.334 3.334 0 0 1 4.713-.001l1.768-1.768z"
  })));
};
export default SvgApiLine;